export default __webpack_public_path__ + "static/media/digital_HIL.337a3fdc.png";